import Decimal from "decimal.js";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { Col, Row, Button, Image, Form, Spinner } from "react-bootstrap";
import reactMoment from "react-day-picker/moment";
import { WidgetContext } from "../../../../../../context/WidgetContext";
import GolfItem from "../../../../../../Data/GolfItem";
import Itinerary from "../../../../../../Data/Itinerary";
import ProductRate from "../../../../../../Data/Rates/ProductRate";
import UnitRate from "../../../../../../Data/Rates/UnitRate";
import { getAvailableVendorUnits, getUnitNameFromVendorUnitId, getVendorUnitIdFromUnitName, getVendorUnitIdsFromSelectedName } from "../../../../../../Data/Rates/UnitRateLogic";
import GolfItineraryUnit from "../../../../../../Data/Reservation/Golf/GolfItineraryUnit";
import VendorUnit from "../../../../../../Data/VendorUnit";
import { roundDecimal, isStringEmpty } from "../../../../../../_helpers/Functions";
import { DatesAndGuests } from "../../../widget-form/WidgetForm";
import CustomDayPickerInput from "../../../../customDayPickerInput/CustomDayPickerInput";
import { TimeOption } from "../../../../../../_helpers/Types";
import MobileUnitTabDetails from "../components/MobileUnitTabDetails";
import UseGetGolfVendors, { GetGolfVendorsRequest } from "../../widget-modals/golf/add-golf/data-service-hooks/UseGetGolfVendors";

interface props {
  itineraryNumber: string;
  itinerary: Itinerary;
  item: GolfItineraryUnit;
  vendor: GolfItem;
  itemIndex: number;
  datesAndGuests: DatesAndGuests;
  removeItem: (unit: GolfItineraryUnit) => void;
  editItem: (unit: GolfItineraryUnit) => void;
  bookNowRequested: boolean;
  quoteRequested: boolean;
  quoteStatus: number | undefined;
  onVendorImageClick: (vendor: GolfItem) => void;
  editable: boolean;
}

interface SameDayReplayData {
  playDate: Date;
  teeTime?: Date;
  players?: number;
}

const GolfTab: React.FC<props> = (props) => {
  const { startWidget, style, fromEmail, viewPortBreakPoint, brandSettings, /* brandId */brand } = useContext(WidgetContext);

  const brandSetting = brandSettings.find((s: any) => s.brandId === brand?.brandId);
  const { itinerary, item, itemIndex, datesAndGuests, removeItem, editItem, bookNowRequested, quoteRequested, quoteStatus } = props;
  const [vendor, setVendor] = useState<GolfItem>(props.vendor);
  // const [unitId, setUnitId] = useState(item.vendorUnitId);
  const [playDate, setPlayDate] = useState<Date>(moment(item.startDate).toDate());
  const [players, setPlayers] = useState(item.numberOfGuests);

  const { formatDate, parseDate } = reactMoment;
  const [sameDayReplays, setSameDayReplays] = useState<SameDayReplayData[]>([]);

  const [selectedUnit, setSelectedUnit] = useState<number | null>(item.vendorUnitId);
  const [selectedTeeTime, setSelectedTeeTime] = useState<string | null>(item.startTime);
  const [productRate, setProductRate] = useState<ProductRate>();

  const [teeTimes, setTeeTimes] = useState<TimeOption[]>([]);
  const [ratesForPlayDate, setRatesForPlayDate] = useState<UnitRate[]>([]);
  const [unavailableMessage, setUnavailableMessage] = useState<string>('');
  const [ratesForUnit, setRatesForUnit] = useState<ProductRate[]>([]);
  const [teeTimeRate, setTeeTimeRate] = useState<Decimal | undefined>();
  const [vendorUnits, setVendorUnits] = useState<VendorUnit[]>([]);

  const rates = vendor && vendor.dailyRates ? vendor.dailyRates : [];
  const [selectedUnitName, setSelectedUnitName] = useState<string | null>(item.unitName || getUnitNameFromVendorUnitId(rates, item.vendorUnitId));

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [getGolfVendorsRequest, setGetGolfVendorsRequest] = useState<GetGolfVendorsRequest>();
  const responseGetGolfVendors = UseGetGolfVendors(getGolfVendorsRequest);

  const [errorsImg, setErrorsImg] = useState<string | undefined>();
  const placeholderImgUrl = "https://images.unsplash.com/photo-1566073771259-6a8506099945?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80";
  const vendorImageUrl = errorsImg ? errorsImg : (vendor.description ?
    (vendor.description.vendorDescriptionImages.length > 0 ?
      ((vendor.description.vendorDescriptionImages[0].vendorImageUrl != undefined && vendor.description.vendorDescriptionImages[0].vendorImageUrl.length > 0) ? vendor.description.vendorDescriptionImages[0].vendorImageUrl
        : placeholderImgUrl)
      : placeholderImgUrl)
    : placeholderImgUrl);

  useEffect(() => {
    setVendor(props.vendor);
    setGetGolfVendorsRequest({ brandId: brand?.brandId as number, startDate: moment(playDate).format('YYYY-MM-DD'), endDate: moment(playDate).format('YYYY-MM-DD'), vendorId: vendor.vendorId });
  }, [props.vendor]);

  // function addSameDayReplay() {
  //   if (item.startDate) {
  //     sameDayReplays.push({ playDate: moment(item.startDate).toDate() });
  //     setSameDayReplays([...sameDayReplays]);
  //   }
  // }

  const playDateChanged = (date: Date) => {
    setPlayDate(date);
  }

  const onPlayersInputChanged = (event: any) => {
    setPlayers(+event.target.value);
  };

  // const onTeeTimeInputChanged = (event: any) => {
  //   setSelectedTeeTime(event.target.value);
  // };

  const teeTimesOptions = teeTimes.map((teeTime: TimeOption, index: number) => (
    <option value={teeTime.value} key={index}>{teeTime.label}</option>
  ));

  const unitOptions = vendorUnits.filter(u => !props.editable || u.published).map((unit: VendorUnit, index: number) => (
    <option value={unit.uniqueIdForSelection} key={index}>{unit.unitName}</option>
  ));

  function populateTeeTimes() {
    const selectedPlayDate = moment(playDate).format('YYYY-MM-DD');
    const ratesForDate = rates.find(rate => selectedPlayDate.toString() === moment(rate.date).format('YYYY-MM-DD').toString());

    if (ratesForDate) {
      const selectedRates = ratesForDate.unitRates.filter(a => a.vendorUnitDisplayName === selectedUnitName);
      // const ratesForUnit = ratesForDate.unitRates.filter(a => a.vendorUnitDisplayName === selectedUnitName).flatMap(a => a.rates);
      const ratesForUnit = selectedRates.flatMap(a => a.rates);

      // Set the tee times.
      let rateTeeTimes: TimeOption[] = [];
      ratesForUnit.forEach(r => {
        let start = moment(r.startTime, 'HH:mm');
        let end = moment(r.endTime, 'HH:mm');

        // pbpkg stuffs
        const pkgStart = props.editable && item.preBuiltPkgVendorUnit !== undefined ? moment(item.preBuiltPkgVendorUnit.fromTime, "HH:mm") : start;
        const pkgEnd = props.editable && item.preBuiltPkgVendorUnit !== undefined ? moment(item.preBuiltPkgVendorUnit.toTime, "HH:mm") : end;

        if (r.startTime !== r.endTime)
          start.minutes(Math.ceil(start.minutes() / 10) * 10);

        let result: TimeOption[] = [];
        let current = moment(start);

        while (current <= end) {
          if (current >= pkgStart && current <= pkgEnd) {
            result.push({
              value: current.format('HH:mm'),
              label: current.format('hh:mm a') + (r.isLive ? ` (${r.openSpots} players)` : ""),
              foreUpTeeTimeId: r.isLive ? r.foreUpTeeTimeId : "",
              golfNowTeeTimeId: r.isLive ? r.golfNowTeeTimeId : "",
              lightSpeedTeeTimeId: r.isLive ? r.lightSpeedTeeTimeId : "",
              openSpots: r.openSpots,
              price: r.price,
              isLive: r.isLive,
              vendorUnitId: r.vendorUnitId,
              productRateId: r.productRateId,
            });
          }

          current.add(10, 'minutes');
        }
        rateTeeTimes = rateTeeTimes.concat(result);
      });
      if (!!rateTeeTimes.length) {
        rateTeeTimes = [...new Map(rateTeeTimes.map(item => [item.value, item])).values()] // Remove any cross-over duplicates.
      }
      rateTeeTimes.sort((a, b) => {
        // Sort by time.
        return moment(a.value, 'HH:mm').isBefore(moment(b.value, 'HH:mm')) ? -1 : 0;
      });

      // if (!item.startTime && !!rateTeeTimes.length) {
      if (!item.startTime && !!rateTeeTimes.length) {
        setSelectedTeeTime(rateTeeTimes[0].value);
        setUnavailableMessage('');
      }

      item.availableTimes = rateTeeTimes;
      setTeeTimes(rateTeeTimes);
      if (ratesForDate.unavailable) {
        setUnavailableMessage(ratesForDate.unavailableMessage || "Unavailable");
      } else if (selectedRates.some(r => r.unavailable)) {
        setUnavailableMessage(selectedRates[0].unavailableMessage);
      } else if (rateTeeTimes.length === 0) {
        setUnavailableMessage("No rates available for this date");
      }
    }
  }

  const playerOptions = Array.from({
    length: Math.min(productRate !== undefined && productRate.isLive ?
      Math.min(productRate.openSpots, 4) : players, players)
  }, (_, i) => i + 1).map((number: number, index: number) => (
    <option value={number} key={index}>{number}</option>
  ));

  function getPriceString() {
    if (brandSetting && brandSetting.usePkgPriceByCourse && itinerary.golfItineraries && itinerary.golfItineraries[0].itineraryUnits.length >= brandSetting.usePkgPriceByCourseNumber) return "Package Price";
    return "$" + (quoteStatus !== undefined ? item.sell.toFixed(2) : (unitRate()).toFixed(2));
    // return (0).toFixed(2);
  }

  function unitRate(): number {
    if (!teeTimeRate) {
      return 0;
    }

    return roundDecimal(teeTimeRate.times(players)).toNumber();
  }

  useEffect(() => {
    setSelectedTeeTime(item.startTime);
    setPlayDate(moment(item.startDate).toDate());
  }, [item]);

  useEffect(() => {
    if (!vendor) return;

    const _vendorUnits = getAvailableVendorUnits(props.vendor.vendorUnits, rates, moment(playDate).format("MM/DD/YYYY"));
    setVendorUnits(_vendorUnits);

    if (_vendorUnits.findIndex(a => a.uniqueIdForSelection === selectedUnitName) < 0) {
      if (_vendorUnits.length > 0) {
        setSelectedUnitName(_vendorUnits[0].uniqueIdForSelection);
      }
    }

    setUnavailableMessage("");
    populateTeeTimes();

  }, [vendor, playDate]);

  useEffect(() => {
    populateTeeTimes();
  }, [selectedUnitName]);

  useEffect(() => {
    setUnavailableMessage("");

    const selectedPlayDate = moment(playDate).format('YYYY-MM-DD');
    const ratesForDate = rates.find(rate => selectedPlayDate.toString() === moment(rate.date).format('YYYY-MM-DD').toString());

    setRatesForPlayDate([]);

    if (!selectedTeeTime || !ratesForDate) {
      setTeeTimeRate(undefined);
      setProductRate(undefined);
      return;
    }

    if (ratesForDate.unavailable || ratesForDate.unitRates.length == 0) {
      var message = ratesForDate.unavailable ? ratesForDate.unavailableMessage as string : "No rates available for the play date.";
      setUnavailableMessage(message)

      if (ratesForDate.unitRates.length == 0) {
        setRatesForPlayDate([]);
        setTeeTimeRate(new Decimal(0));
        setTeeTimeRate(undefined);
        return;
      }
    }

    setRatesForPlayDate(ratesForDate.unitRates);

    const ratesForUnit = ratesForDate.unitRates.filter(r => r.vendorUnitDisplayName === selectedUnitName).flatMap(a => a.rates);
    setRatesForUnit(ratesForUnit);

    if (ratesForDate.unavailable || teeTimes.length === 0) {
      setUnavailableMessage(ratesForDate.unavailableMessage || "Unavailable");
    }

    const unitIds = getVendorUnitIdsFromSelectedName(rates, selectedUnitName, moment(playDate).format("MM/DD/YYYY"));
    const teeTimeRate = ratesForUnit.find(r => moment(r.startTime, "HH:mm").isSameOrBefore(moment(selectedTeeTime, "HH:mm")) && moment(r.endTime, "HH:mm").isSameOrAfter(moment(selectedTeeTime, "HH:mm")) && unitIds.includes(r.vendorUnitId));

    if (teeTimeRate) {
      setSelectedUnit(teeTimeRate ? teeTimeRate.vendorUnitId : null);
    }

    setTeeTimeRate(new Decimal(teeTimeRate ? teeTimeRate.price : 0));
    setProductRate(teeTimeRate);
  }, [selectedTeeTime, selectedUnitName, playDate, teeTimes, vendor]);

  useEffect(() => {
    if (quoteRequested || bookNowRequested) {
      item.startDate = moment(playDate).format("YYYY-MM-DD");
      // item.vendorUnitId = unitId;
      item.vendorUnitId = selectedUnit as number;
      item.startTime = selectedTeeTime as string;
      item.numberOfGuests = players;

      item.productRateId = productRate !== undefined ? productRate.productRateId : 0;
      item.foreUpTeeTimeId = productRate !== undefined ? productRate.foreUpTeeTimeId : "";
      item.golfNowTeeTimeId = productRate !== undefined ? productRate.golfNowTeeTimeId : "";
      item.lightSpeedTeeTimeId = productRate !== undefined ? productRate.lightSpeedTeeTimeId : "";

      item.sell = unitRate();

      item.isValid = isStringEmpty(unavailableMessage);
    }
  }, [quoteRequested, bookNowRequested]);

  useEffect(() => {
    if (responseGetGolfVendors.data) {
      const responseData = responseGetGolfVendors.data;

      if (responseData.length > 0) {
        setVendor({ ...responseData[0] });
      }
      setIsLoading(false);
    }
  }, [responseGetGolfVendors.data]);

  return (
    <React.Fragment>
      {item.showOnItinerary && (
        <>
          {/* Desktop */}
          <Row className="d-none d-md-flex item-container">
            <Col xs={3} className="d-flex justify-content-start image-col">
              <Image
                style={{ padding: "0" }}
                className="d-flex item-image-desktop"
                // src={""}
                src={vendorImageUrl}
                onClick={() => props.onVendorImageClick(props.vendor)}
                fluid
              />
            </Col>

            <Col xs={10} className="d-flex flex-column pl-3" style={{ maxWidth: 'calc(100% - 250px)' }}>
              <Row>
                <h5
                  className="form-header itinerary-font"
                  style={{ color: style.fontColor }}
                >
                  {vendor ? vendor.vendorName : ""}
                </h5>
                <p
                  className="itinerary-font ml-3 mt-3"
                  style={{ color: style.fontColor }}
                >
                  {vendor ? vendor.city : ""}, {vendor ? vendor.state : ""}
                </p>
              </Row>

              <div className="d-flex flex-row">
                {/* DatePickers */}
                <Col xs={4} className="d-flex flex-column p-0 pr-1 InputFromTo">
                  <Form.Label className="font-weight-bold" style={{ color: style.fontColor, fontSize: 14 }}>
                    Date of Play
                  </Form.Label>
                  <CustomDayPickerInput
                    // overlayComponent={MobileDayPickerOverlay}
                    inputProps={{ readOnly: !props.editable || !isStringEmpty(props.itineraryNumber), disabled: !props.editable || !isStringEmpty(props.itineraryNumber), style: { color: style.fontColor, borderColor: isStringEmpty(props.itineraryNumber) && teeTimesOptions.length === 0 ? "red" : "" } }}
                    value={moment(playDate).format("ddd, MMM Do, YYYY")}
                    placeholder="From"
                    format="LL"
                    formatDate={formatDate}
                    parseDate={parseDate}
                    dayPickerProps={{
                      selectedDays: [playDate ? playDate : datesAndGuests.fromDate],
                      disabledDays: { before: datesAndGuests.fromDate, after: datesAndGuests.toDate },
                      month: datesAndGuests.fromDate,
                      numberOfMonths: 1,
                      modifiers: { start: playDate ? playDate : datesAndGuests.fromDate, end: playDate ? playDate : datesAndGuests.fromDate }
                    }}
                    onDayChange={playDateChanged}
                  />
                </Col>
                {/* Tee Time Select */}
                <Row className={`d-flex m-0 p-0 pl-1 ${quoteStatus === undefined ? "mr-0" : "mr-1"}`} style={{ width: 'calc(100% - 0.5rem)' }}>
                  <Col xs={quoteStatus === undefined ? 12 : 6} className="d-flex flex-column pr-1 pl-0" style={{ minWidth: 0 }}>
                    <Form.Label className="font-weight-bold" style={{ color: style.fontColor, fontSize: 14 }}>
                      Tee Time
                    </Form.Label>

                    {!isStringEmpty(props.itineraryNumber) && (
                      <Form.Control
                        className="font-italic time-select"
                        style={{ color: style.fontColor }}
                        type="text"
                        value={moment(item.confirmedTime ? item.confirmedTime : selectedTeeTime as string, "HH:mm").format("hh:mm a")}
                        readOnly={true}
                        disabled={true}
                      >
                      </Form.Control>
                    )}
                    {isStringEmpty(props.itineraryNumber) && (
                      <Form.Control style={{ color: style.fontColor }} as="select" name="teeTime" value={selectedTeeTime || undefined} className="time-select p-1"
                        onChange={(event: any) => setSelectedTeeTime(event.currentTarget.value)}
                        readOnly={!props.editable || quoteStatus !== undefined || teeTimesOptions.length === 0}
                        disabled={!props.editable || quoteStatus !== undefined || teeTimesOptions.length === 0}
                      >
                        {teeTimesOptions}
                      </Form.Control>
                    )}
                  </Col>
                  {(quoteStatus == 20 || quoteStatus == 30 || quoteStatus == 60) && (
                    <Col xs={6} className="d-flex flex-column pl-1 pr-0" style={{ minWidth: 0, whiteSpace: 'nowrap' }}>
                      <Form.Label className="font-weight-bold" style={{ color: style.fontColor, fontSize: 14 }}>
                        Confirmed Time
                      </Form.Label>
                      <Form.Control
                        className="font-italic time-select"
                        style={{ color: item.confirmedTime ? "green" : "red" }}
                        type="text"
                        value={item.confirmedTime ? moment(item.confirmedTime, "HH:mm").format("hh:mm a") : "Pending"}
                        readOnly={true}
                        disabled={true}
                      >
                      </Form.Control>
                    </Col>
                  )}
                </Row>
                {/* Guests Select */}
                <div className="d-flex flex-column ml-1">
                  <Form.Label className="font-weight-bold" style={{ color: style.fontColor, fontSize: 14 }}>
                    Players
                  </Form.Label>
                  {!isStringEmpty(props.itineraryNumber) ? (
                    <Form.Control
                      style={{ color: style.fontColor }}
                      type="text"
                      name="players"
                      className="guest-select"
                      disabled={true}
                      readOnly={true}
                      value={item.numberOfGuests}
                    >
                    </Form.Control>
                  ) : (
                      <Form.Control
                        style={{ color: style.fontColor }}
                        as="select"
                        name="players"
                        className="guest-select"
                        // defaultValue={item.numberOfGuests > playerOptions.length ? playerOptions.length.toString() : item.numberOfGuests.toString()}
                        defaultValue={playerOptions.length.toString()}
                        // defaultValue={item.numberOfGuests.toString()}
                        onChange={onPlayersInputChanged}
                        disabled={!props.editable || quoteStatus !== undefined}
                        readOnly={!props.editable || quoteStatus !== undefined}
                      >
                        {playerOptions}
                      </Form.Control>
                    )}
                </div>
                <Col xs={3} className="d-flex flex-column m-0 p-0 mr-0 ml-2" style={{ justifyContent: 'flex-end' }}>
                  {teeTimesOptions.length > 0 && props.quoteStatus !== 40 && props.quoteStatus !== 50 && (props.quoteStatus !== 10 || !!!unavailableMessage) && (
                    <div className="add-buttons">
                      <p className="m-0 p-0 text-right font-weight-bold green-text">{!vendor.rateDisplayOption.showPkgPriceOnly && startWidget.showGolfPricing ? getPriceString() : "Package Price"}</p>
                    </div>
                  )}

                  {(props.quoteStatus === 40 || props.quoteStatus === 50) && (
                    <div className="add-buttons">
                      <p className="m-0 p-0 text-right red-text font-italic">Cancelled</p>
                    </div>
                  )}

                  {(props.quoteStatus === undefined || props.quoteStatus === 10) && unavailableMessage && (
                    <div className="add-buttons">
                      <p className="m-0 p-0 red-text text-right font-italic">{unavailableMessage}</p>
                    </div>
                  )}
                  {/* {unavailableMessage && (
                    <div className="add-buttons">
                      <p className="m-0 p-0 red-text text-right font-italic">{unavailableMessage}</p>
                    </div>
                  )} */}
                </Col>
              </div>

              {!isLoading && (
                <div className="d-flex flex-row" style={{ marginTop: "10px" }}>
                  <Col xs={8} className="d-flex flex-column">
                    <Form.Label className="font-weight-bold" style={{ color: style.fontColor, fontSize: 14 }}>
                      Unit Type
                  </Form.Label>
                    {!isStringEmpty(props.itineraryNumber) || item.preBuiltPkgVendorUnit !== undefined ? (
                      <Form.Control
                        style={{ color: style.fontColor }}
                        type="text"
                        disabled={true}
                        readOnly={true}
                        value={item.unitName}
                      >
                      </Form.Control>
                    ) : (
                        <Form.Control
                          style={{ color: style.fontColor }}
                          as="select"
                          className=""
                          disabled={!props.editable || quoteStatus !== undefined}
                          readOnly={!props.editable || quoteStatus !== undefined}
                          value={selectedUnitName || undefined}
                          onChange={(event: any) => {
                            setSelectedUnitName(event.currentTarget.value)
                          }} >
                          <option value="" disabled hidden>Select a unit</option>
                          {unitOptions}
                        </Form.Control>
                      )}
                  </Col>

                  {(quoteStatus == 20 || quoteStatus == 30 || quoteStatus == 60) && (
                    <>
                      <Col xs={4} className="d-flex flex-column m-0 p-0 mr-0 pr-2 ml-2">
                        <Form.Label className="font-weight-bold" style={{ color: style.fontColor, fontSize: 14 }}>
                          Confirmation #
                      </Form.Label>
                        <Form.Control
                          className="font-italic"
                          style={{ color: item.confirmationNumber ? "green" : "red" }}
                          type="text"
                          value={item.confirmationNumber ? item.confirmationNumber : "Pending"}
                          readOnly={true}
                          disabled={true}
                        >
                        </Form.Control>
                      </Col>
                    </>
                  )}
                  {(quoteStatus == 40 || quoteStatus == 50) && (
                    <Col xs={4} className="d-flex flex-column m-0 p-0 mr-0 ml-2">
                      <Form.Label className="font-weight-bold" style={{ color: style.fontColor, fontSize: 14 }}>
                        Cancellation #
                    </Form.Label>
                      <Form.Control
                        className="font-italic"
                        style={{ color: item.cancellationNumber ? "green" : "red" }}
                        type="text"
                        value={item.cancellationNumber ? item.cancellationNumber : "Pending Cancellation"}
                        readOnly={true}
                        disabled={true}
                      >
                      </Form.Control>
                    </Col>
                  )}
                  {quoteStatus === undefined && props.editable && (
                    <Col
                      className={"d-flex flex-column justify-content-end"}
                    >
                      <Button
                        size="sm"
                        style={{
                          backgroundColor: "#C50505",
                          border: "none",
                          height: "30px",
                          width: 'auto',
                          alignSelf: 'self-end'
                        }}
                        onClick={() => {
                          removeItem(item);
                        }}
                      >
                        Remove
                      </Button>
                    </Col>
                  )}
                </div>
              )}

              {isLoading && (
                <span className="mt-2"><Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                /> Loading...</span>
              )}
            </Col>
          </Row>

          {/* Mobile  */}
          <MobileUnitTabDetails
            vendor={vendor}
            showPricing={startWidget.showGolfPricing}
            editable={props.editable}
            getPriceString={getPriceString}
            editItem={editItem}
            removeItem={removeItem}
            item={item}
            quoteStatus={quoteStatus}
          >
            <h6 style={{ color: style.fontColor, fontSize: 14 }} className="mobile-item-header">{vendor ? vendor.vendorName : ""}</h6>
            <p style={{ color: style.fontColor, fontSize: 14 }} className="m-0 p-0">{moment(item.startDate).format("MMM Do, YYYY")}</p>
            <p style={{ color: style.fontColor, fontSize: 14 }} className="m-0 p-0">{item.numberOfGuests} Player{item.numberOfGuests == 1 ? "" : "s"}</p>
            <p style={{ color: style.fontColor, fontSize: 14 }} className="m-0 p-0">{item.numberOfGuests ? item.numberOfGuests : 1} Unit{item.numberOfGuests && item.numberOfGuests != 1 ? "s" : ""}
              <span className="m-0 p-0">&nbsp;{selectedUnitName} - {`${(item.confirmedTime ? moment(item.confirmedTime, "HH:mm").format("hh:mm a") : moment(selectedTeeTime, "HH:mm").format('hh:mm a'))}`}</span>
            </p>
          </MobileUnitTabDetails>
        </>
      )}
    </React.Fragment>
  );
}

export default GolfTab;